import { OrderSource, PortalApiVersion } from '@afterpaytouch/portal-api/types'
import { isAppleRetailOrder } from './helper'

export const getCheckoutApiVersionForOrderSource = (orderSource: OrderSource | unknown): PortalApiVersion => {
  if (isAppleRetailOrder(orderSource)) {
    return 'v2'
  }
  return ''
}
